import { ChevronLeft } from "lucide-react";
import {
  LANDING_ASSETS,
  LANDING_CATEGORY_HERO_TYPOGRAPHY,
  LANDING_PAGE_GUTTER,
} from "../constants/landing.constants";

interface CategoryHeroProps {
  badge: string;
  title: string;
  heroImage: string;
  onBack?: () => void;
}

export default function CategoryHero({ badge, title, heroImage, onBack }: CategoryHeroProps) {
  return (
    <section className="relative h-[236px] max-h-[236px] overflow-hidden bg-landing-navy">
      <img
        src={LANDING_ASSETS.categoryHeroBg}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
        aria-hidden
      />

      <div
        className={`relative z-10 flex h-full max-h-[236px] flex-col justify-center gap-3 py-6 ${LANDING_PAGE_GUTTER}`}
      >
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="flex w-fit items-center gap-1 text-[14px] font-medium text-white/90 transition-opacity hover:text-white"
          >
            <ChevronLeft className="h-5 w-5" />
            Back
          </button>
        ) : null}

        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 flex-1 md:pr-4">
            <span className={LANDING_CATEGORY_HERO_TYPOGRAPHY.badge} title={badge}>
              {badge}
            </span>
            <h1 className={LANDING_CATEGORY_HERO_TYPOGRAPHY.title} title={title}>
              {title}
            </h1>
          </div>
          <img
            src={heroImage}
            alt=""
            className="hidden h-[140px] w-auto shrink-0 object-contain md:block min-[1440px]:h-[180px]"
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
}
